import { REQUIRED_PAYLOAD_KEYS } from "./domain-event.constants";

// Pure helpers of the Domain Event tab (no API, no React).

/** Payload keys an event adds to the required ones. */
export const extraPayload = (payloadSchema) => (payloadSchema ?? []).filter((item) => !REQUIRED_PAYLOAD_KEYS.includes(item.key));

/** The source a form points at. */
export const sourceOf = (formData, dependencies) => (dependencies?.sources || []).find((source) => source.id === formData?.source_fid) ?? null;

/** Why the picked source can't serve the event yet (empty when it can). The server repeats these on save. */
export function sourceNotes(source) {
  if (!source) return [];
  if (source.status === "ARCHIVED") return [`${source.label} is archived; pick another source.`];
  const notes = [];
  if (!source.has_reference) notes.push(`${source.label} has no REFERENCE field yet, so the payload's reference_key can't be matched. Add one in Source Field.`);
  if (source.status !== "ACTIVE") notes.push(`${source.label} is not published yet; publish it before a trigger uses this event.`);
  return notes;
}

/** EntityFormModal values -> create / update payload. */
export const toDomainEventPayload = (values) => ({
  event_key: values.event_key?.trim() ?? "",
  name: values.name?.trim() ?? "",
  description: values.description?.trim() || null,
  source_fid: values.source_fid,
  payload_schema: (values.payload_schema ?? []).map((item) => ({
    key: item.key?.trim() ?? "",
    label: item.label?.trim() || item.key?.trim() || "",
    data_type: item.data_type || "TEXT",
  })),
  sort_order: values.sort_order === "" || values.sort_order === null || values.sort_order === undefined ? 0 : Number(values.sort_order),
  is_activated: !!values.is_activated,
});
